export type Plan = {
  id: number;
  code: string;
  name: string;
  products: string[];
  description?: string | null;
  active: boolean;
};

export type Subscription = {
  id: number;
  account_id: number;
  plan_id: number;
  status: string;
  starts_at: string;
  ends_at: string;
  effective: boolean;
  products: string[];
};

/** Compact YYYY-MM-DD for ~224px sidebar eyebrow (avoids CJK long-form truncate). */
function formatExpiryDate(iso: string): string {
  try {
    const date = new Date(iso);
    if (Number.isNaN(date.getTime())) return iso;
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, "0");
    const d = String(date.getDate()).padStart(2, "0");
    return `${y}-${m}-${d}`;
  } catch {
    return iso;
  }
}

/** Prefer the effective subscription with the latest end date. */
export function pickCurrentSubscription(subscriptions: Subscription[]): Subscription | null {
  const effective = subscriptions.filter((item) => item.effective);
  if (effective.length === 0) return null;
  return effective.sort(
    (left, right) => new Date(right.ends_at).getTime() - new Date(left.ends_at).getTime(),
  )[0];
}

export function formatAccountPlanEyebrow(
  subscription: Subscription | null,
  planName: string | null,
): string {
  if (!subscription) return "未开通套餐";
  const name = planName ?? `套餐 #${subscription.plan_id}`;
  return `${name} · 到期 ${formatExpiryDate(subscription.ends_at)}`;
}

export function resolveAccountPlanEyebrow(
  subscriptions: Subscription[],
  plans: Plan[],
): string {
  const current = pickCurrentSubscription(subscriptions);
  if (!current) return "未开通套餐";
  const plan = plans.find((item) => item.id === current.plan_id);
  return formatAccountPlanEyebrow(current, plan?.name ?? null);
}
